!function (e, t) {
  for (var n in t) {
    e[n] = t[n];
  }
}(exports, function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 5);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("@material-ui/core");
}, function (e, t) {
  e.exports = require("@material-ui/core/styles/createPalette");
}, function (e, t) {
  e.exports = require("@coderehab/greenzeen-content");
}, function (e, t) {
  e.exports = require("react-color");
}, function (e, t, n) {
  "use strict";

  function r(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function o(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? r(Object(n), !0).forEach(function (t) {
        a(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function a(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  n.r(t), n.d(t, "useThemeCollection", function () {
    return he;
  }), n.d(t, "useTheme", function () {
    return xe;
  }), n.d(t, "createFonts", function () {
    return y;
  }), n.d(t, "createTheme", function () {
    return h;
  }), n.d(t, "createTypography", function () {
    return i;
  }), n.d(t, "ColorPicker", function () {
    return Fe;
  }), n.d(t, "FontSelect", function () {
    return De;
  }), n.d(t, "TypographyVariantSelect", function () {
    return ke;
  }), n.d(t, "themes", function () {
    return ge;
  }), n.d(t, "getTheme", function () {
    return de;
  }), n.d(t, "Themes", function () {
    return Oe;
  });

  var i = function i(e) {
    var t = {
      h1: o({
        name: "Heading 1"
      }, e.h1 || {}),
      h2: o({
        name: "Heading 2"
      }, e.h2 || {}),
      h3: o({
        name: "Heading 3"
      }, e.h3 || {}),
      h4: o({
        name: "Heading 4"
      }, e.h4 || {}),
      h5: o({
        name: "Heading 5"
      }, e.h5 || {}),
      h6: o({
        name: "Heading 6"
      }, e.h6 || {}),
      body1: o({
        name: "Body 1"
      }, e.body1 || {}),
      body2: o({
        name: "Body 2"
      }, e.body2 || {}),
      subtitle1: o({
        name: "Subtitle 1"
      }, e.subtitle1 || {}),
      subtitle2: o({
        name: "Subtitle 2"
      }, e.subtitle2 || {}),
      button: o({
        name: "Button"
      }, e.button || {}),
      caption: o({
        name: "Caption"
      }, e.caption || {}),
      overline: o({
        name: "Overline"
      }, e.overline || {})
    };
    return o(o({}, e), t);
  },
      l = n(2),
      s = n.n(l),
      f = n(1);

  function c(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function m(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? c(Object(n), !0).forEach(function (t) {
        u(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function u(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var p = function p(e, t) {
    return Object(f.createMuiTheme)(m(m({}, t), {}, {
      typography: m({
        body1: m({}, e.body1.style || {}),
        body2: m({}, e.body2.style || {}),
        h1: m({}, e.h1.style || {}),
        h2: m({}, e.h2.style || {}),
        h3: m({}, e.h3.style || {}),
        h4: m({}, e.h4.style || {}),
        h5: m({}, e.h5.style || {}),
        h6: m({}, e.h6.style || {}),
        button: m({}, e.button.style || {}),
        subtitle1: m({}, e.subtitle1.style || {}),
        subtitle2: m({}, e.subtitle2.style || {}),
        overline: m({}, e.overline.style || {}),
        caption: m({}, e.caption.style || {})
      }, t.typography)
    }));
  },
      y = function y(e) {
    return e;
  };

  function g(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function d(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var h = function h(e) {
    var t = e.typography || i({}),
        n = e.palette || s()({});
    return function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? g(Object(n), !0).forEach(function (t) {
          d(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : g(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }({
      fonts: e.fonts || y({}),
      typography: t,
      palette: n,
      MuiTheme: e.MuiTheme || p(t, {
        palette: n
      }),
      stylesheet: e.stylesheet || "",
      colorList: e.colorList || [],
      elements: e.elements || {},
      elementConfig: e.elementConfig || {}
    }, e);
  },
      b = y({
    primary: {
      name: "Muse0",
      fontFamily: "Museo, sans-serif"
    },
    secondary: {
      name: "Typewriter",
      fontFamily: "urwtypewriterw01-mediumwideRg"
    },
    tertiary: {
      name: "Amaranth",
      fontFamily: "Amaranth, sans-serif"
    }
  }),
      w = i({
    h1: {
      name: "Koptekst",
      component: "h1",
      style: {
        fontFamily: b.secondary.fontFamily,
        fontSize: "calc(1rem + 2.9em + 1vw)",
        lineHeight: 0.84,
        letterSpacing: "0.02em",
        textTransform: "unset"
      }
    },
    h2: {
      name: "Subtitel",
      component: "h2",
      style: {
        fontFamily: b.tertiary.fontFamily,
        fontSize: "calc(1rem + 1.2em + 0.6vw)",
        lineHeight: 1,
        letterSpacing: "0.02em",
        textTransform: "unset"
      }
    },
    h3: {
      name: "Introtekst",
      component: "h3",
      style: {
        fontFamily: b.tertiary.fontFamily,
        fontSize: "calc(1rem + 0.28em + 0.15vw)",
        lineHeight: 1.38,
        letterSpacing: "0.02em",
        textTransform: "unset"
      }
    },
    h4: {
      name: "Sub-subtitel",
      component: "h4",
      style: {
        fontFamily: b.secondary.fontFamily,
        fontSize: "calc(1rem + 0.8em + 0.34vw)",
        lineHeight: 1.2,
        letterSpacing: "0.02em",
        textTransform: "unset"
      }
    },
    h5: {
      name: "Bijschrift",
      component: "h5",
      style: {
        fontFamily: b.tertiary.fontFamily,
        fontSize: "calc(1rem + 0.5em)",
        lineHeight: 1.2,
        letterSpacing: "0.02em",
        textTransform: "unset"
      }
    },
    h6: {
      name: "Paragraaf",
      component: "h6",
      style: {
        fontFamily: b.tertiary.fontFamily,
        fontSize: "calc(1.1rem + 0.2em)",
        lineHeight: 1.2,
        letterSpacing: "0.02em",
        fontWeight: 400,
        textTransform: "unset"
      }
    },
    caption: {
      name: "Caption",
      style: {
        fontSize: "calc(0.5rem + 0.1em + 0.15vw)",
        lineHeight: 1.33
      }
    },
    button: {
      name: "Button",
      style: {
        textTransform: "none",
        fontSize: "calc(0.875rem + 0.1em + 0.05vw)"
      }
    },
    body1: {
      name: "Body 1",
      style: {
        fontFamily: b.primary.fontFamily,
        fontSize: "calc(0.5rem + 0.1em + 0.34vw)",
        lineHeight: 2
      }
    },
    body2: {
      name: "Body 2",
      style: {
        fontFamily: b.primary.fontFamily,
        fontSize: "calc(0.5rem + 0.1em + 0.34vw)",
        lineHeight: 2
      }
    }
  }),
      v = {
    primary: {
      main: "#FCC500",
      dark: "#AD8700",
      light: "#F2E699"
    },
    secondary: {
      main: "#01AEC2",
      dark: "#0695A5",
      light: "#74C2D2"
    },
    orange: {
      main: "#F39200",
      light: "#FAF1E4"
    },
    marine: {
      main: "#3E386C",
      light: "#E9E7F7"
    },
    purple: {
      main: "#7A5394",
      light: "#F0E7F7"
    },
    red: {
      main: "#E94D36",
      dark: "#9D353B",
      darker: "#4D1A1D",
      light: "#F4E3E1"
    },
    fuchsia: {
      main: "#E94D36",
      light: "#F4DBDC"
    },
    ocean: {
      main: "#EB5058",
      light: "#E4EEF7"
    },
    aquaGreen: {
      main: "#6CBD99",
      light: "#CDE3DA"
    },
    forestGreen: {
      main: "#79A358",
      light: "#DDEAD3"
    },
    springGreen: {
      main: "#83B74D",
      light: "#DDEDCD"
    },
    beige: "#F8EFE7",
    text: {
      primary: "#3F3F3F"
    }
  },
      S = s()({
    primary: v.primary,
    secondary: v.secondary,
    error: v.red,
    text: v.text
  }),
      O = ["#fff", "#000", v.text.primary, v.primary.main, v.primary.light, v.secondary.main, v.secondary.light, v.orange.main, v.orange.light, v.marine.main, v.marine.light, v.purple.main, v.purple.light, v.red.main, v.red.light, v.fuchsia.main, v.fuchsia.light, v.ocean.main, v.ocean.light, v.aquaGreen.main, v.aquaGreen.light, v.forestGreen.main, v.forestGreen.light, v.springGreen.main, v.springGreen.light, v.beige],
      x = p(w, {
    spacing: 12,
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
      }
    },
    palette: S,
    shape: {
      borderRadius: 0
    },
    props: {
      MuiCard: {
        elevation: 0
      },
      MuiExpansionPanel: {
        elevation: 0
      },
      MuiInputLabel: {
        shrink: !0
      },
      MuiTypography: {
        variant: "body2"
      }
    },
    overrides: {
      MuiTypography: {
        paragraph: {
          marginBottom: "1.2rem"
        },
        gutterBottom: {
          marginBottom: "1.8rem"
        }
      },
      MuiButton: {
        outlined: {
          borderRadius: 50,
          paddingLeft: 36,
          paddingRight: 36
        }
      },
      MuiLink: {
        root: {
          color: "inherit"
        }
      }
    }
  }),
      j = window.location.origin,
      F = "\n@import url('https://fonts.googleapis.com/css2?family=Bree+Serif&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Amaranth&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap');\n   @import url(\"https://fonts.googleapis.com/css2?family=Neuton:ital@1&display=swap\");\n  \n\n@font-face {\n  font-family: 'urwtypewriterw01-mediumwideRg';\n  src: url('".concat(j, "/assets/fonts/urw_typewriter_w01_medium_wide-webfont.woff2') format('woff2'),\n       url('").concat(j, "/assets/fonts/urw_typewriter_w01_medium_wide-webfont.woff') format('woff');\n}\n"),
      D = (b.primary.fontFamily, h({
    typography: w,
    fonts: b,
    palette: S,
    stylesheet: F,
    MuiTheme: x,
    colorList: O,
    elementConfig: {
      Quote: {
        config: {
          lineTop: !0
        }
      }
    }
  })),
      E = s()({
    primary: {
      main: "#FCC500",
      dark: "#AD8700",
      light: "#F2E699"
    },
    secondary: {
      main: "#01AEC2",
      dark: "#0695A5",
      light: "#74C2D2"
    }
  }),
      M = ["#fff", "#000", E.primary.dark, E.primary.main, E.primary.light, E.secondary.dark, E.secondary.main, E.secondary.light],
      P = y({
    primary: {
      name: "Amaranth",
      fontFamily: "Amaranth, sans-serif"
    },
    secondary: {
      name: "Bungee",
      fontFamily: "Bungee"
    },
    tertiary: {
      name: "Franchise",
      fontFamily: "franchise, sans-serif"
    }
  }),
      k = i({
    h1_larger: {
      name: "Bigger h1",
      component: "h1",
      style: {}
    },
    h1: {
      name: "Heading 1",
      component: "h1",
      style: {
        color: E.primary.main,
        fontFamily: P.tertiary.fontFamily,
        fontSize: "calc(3rem + 1em + 3vw)",
        lineHeight: 0.8
      }
    },
    h2: {
      name: "Heading 2",
      component: "h2",
      style: {
        color: E.primary.main,
        fontFamily: P.tertiary.fontFamily,
        fontSize: "calc(2rem + 1em + 2vw)",
        lineHeight: 0.85
      }
    },
    h3: {
      name: "Heading 3",
      component: "h3",
      style: {
        fontFamily: P.tertiary.fontFamily,
        fontSize: "calc(1.4rem + 1em + 1.4vw)",
        lineHeight: 0.9
      }
    },
    h4: {
      name: "Heading 4",
      component: "h4",
      style: {
        fontFamily: P.tertiary.fontFamily,
        fontSize: "calc(1.2rem + 0.5em + 0.5vw);",
        lineHeight: 0.9
      }
    },
    h5: {
      name: "Heading 5",
      component: "h5",
      style: {
        fontSize: "calc(1.25rem + 0.25em + 0.25vw);",
        lineHeight: 1.4
      }
    },
    h6: {
      name: "Heading 6",
      component: "h6",
      style: {
        fontSize: "calc(1rem + 0.25em + 0.25vw);",
        lineHeight: 1.4
      }
    },
    caption: {
      name: "Caption",
      style: {
        fontStyle: "italic",
        fontWeight: "bold"
      }
    },
    button: {
      name: "Button",
      style: {}
    },
    body1: {
      name: "Body 1",
      style: {
        lineHeight: 2
      }
    },
    body2: {
      name: "Body 2",
      style: {
        lineHeight: 2
      }
    }
  }),
      T = p(k, {
    spacing: 12,
    typography: {
      fontSize: 15,
      fontFamily: P.primary.fontFamily
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
      }
    },
    palette: E,
    shape: {
      borderRadius: 0
    },
    props: {
      MuiCard: {
        elevation: 0
      },
      MuiExpansionPanel: {
        elevation: 0
      },
      MuiInputLabel: {
        shrink: !0
      }
    },
    overrides: {
      MuiButton: {
        outlined: {
          borderRadius: 50,
          paddingLeft: 36,
          paddingRight: 36
        }
      },
      MuiLink: {
        root: {
          color: "inherit"
        }
      }
    }
  }),
      C = window.location.origin,
      B = "\n@import url('https://fonts.googleapis.com/css2?family=Amaranth:ital,wght@0,400;0,700;1,400;1,700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Bree+Serif&display=swap');\n\n@font-face { \n  font-family: 'franchise'; \n  font-weight: normal; \n  font-style: normal; \n  src: url('".concat(C, "/assets/fonts/franchise-free-bold-webfont.woff2') format('woff'), \n    url('").concat(C, "/assets/fonts/franchise-free-bold-webfont.woff') format('woff'); \n}\n"),
      z = n(0),
      H = Object(f.makeStyles)(function (e) {
    return {
      root: {
        position: "relative",
        maxWidth: 400,
        flex: 1,
        width: "100%",
        "&:hover > $container": {
          transform: "translateY(-5%)",
          boxShadow: e.shadows[20]
        }
      },
      container: {
        transition: "all 0.3s",
        transform: "translateY(0)",
        boxShadow: e.shadows[16],
        "&:after": {
          top: "0",
          left: 0,
          right: 0,
          bottom: 0,
          content: "' '",
          position: "absolute",
          backgroundSize: "cover",
          backgroundImage: "linear-gradient(0deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%)",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top center"
        }
      },
      image: {
        display: "block",
        width: "100%"
      },
      title: {
        position: "absolute",
        color: "#fff",
        bottom: 0,
        zIndex: 10,
        fontSize: "1.5rem",
        fontWeight: 700,
        padding: "7% 10%",
        lineHeight: 1,
        textTransform: "lowercase",
        fontFamily: P.tertiary.fontFamily
      },
      index: {
        position: "absolute",
        background: "#fff",
        width: 46,
        height: 46,
        borderRadius: "100%",
        top: "5%",
        left: -10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: 700,
        fontSize: "1rem",
        zIndex: 11
      }
    };
  });

  function A(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function I(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? A(Object(n), !0).forEach(function (t) {
        R(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : A(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function R(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  P.primary.fontFamily;

  var L = {
    Quote: {
      config: {
        lineTop: !0,
        classes: {
          content: I(I({}, k.h5.style), {}, {
            fontStyle: "normal"
          }),
          author: {
            fontStyle: "normal"
          }
        }
      }
    }
  },
      N = h({
    typography: k,
    fonts: P,
    palette: E,
    stylesheet: B,
    MuiTheme: T,
    colorList: M,
    elements: {
      CoverButton: function CoverButton(e) {
        var t = e.element,
            n = H(),
            r = t.config,
            o = r.image,
            a = r.title,
            i = r.index;
        return z.createElement("div", {
          className: n.root
        }, z.createElement("div", {
          className: n.container
        }, z.createElement("img", {
          className: n.image,
          src: o,
          alt: o
        }), z.createElement("div", {
          className: n.index
        }, i), z.createElement(f.Typography, {
          variant: "body1",
          className: n.title
        }, a)));
      }
    },
    elementConfig: L
  }),
      W = i({
    h1: {
      name: "Koptekst",
      component: "h1",
      style: {}
    },
    h2: {
      name: "Subtitel",
      component: "h2",
      style: {}
    },
    h3: {
      name: "Introtekst",
      component: "h3",
      style: {}
    },
    h4: {
      name: "Sub-subtitel",
      component: "h4",
      style: {}
    },
    h5: {
      name: "Bijschrift",
      component: "h5",
      style: {}
    },
    h6: {
      name: "Paragraaf",
      component: "h6",
      style: {}
    },
    caption: {
      name: "Caption",
      style: {}
    },
    button: {
      name: "Button",
      style: {}
    },
    body1: {
      name: "Body 1",
      style: {}
    },
    body2: {
      name: "Body 2",
      style: {}
    }
  }),
      _ = y({
    primary: {
      name: "Museo",
      fontFamily: "Museo, sans-serif"
    }
  }),
      q = s()({
    primary: {
      main: "#073b3a",
      light: "#607878"
    },
    secondary: {
      main: "#48597e",
      light: "#6e81ac"
    },
    text: {
      primary: "#4D4D4F"
    }
  }),
      G = ["#fff", "#000", q.text.primary, q.primary.main, q.primary.light, q.secondary.main, q.secondary.light, "#DAEAC9"],
      K = p(W, {
    spacing: 12,
    typography: {
      fontFamily: _.primary.fontFamily
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
      }
    },
    palette: q,
    shape: {
      borderRadius: 0
    },
    props: {
      MuiCard: {
        elevation: 0
      },
      MuiExpansionPanel: {
        elevation: 0
      },
      MuiInputLabel: {
        shrink: !0
      },
      MuiTypography: {
        variant: "body2"
      }
    },
    overrides: {
      MuiTypography: {
        paragraph: {
          marginBottom: "1.66em"
        },
        gutterBottom: {
          marginBottom: "0.5em"
        }
      },
      MuiButton: {
        outlined: {
          borderRadius: 50,
          paddingLeft: 36,
          paddingRight: 36
        }
      },
      MuiLink: {
        root: {
          color: "inherit"
        }
      }
    }
  }),
      Q = window.location.origin,
      Y = '\n  @font-face {\n    font-family: "Museo";\n    src: url("'.concat(Q, '/assets/fonts/museosans_500-webfont.woff2") format("woff2"),\n      url("').concat(Q, '/assets/fonts/museosans_500-webfont.woff") format("woff");\n    font-weight: 500;\n    font-style: normal;\n  } \n\n  @font-face {\n    font-family: "Museo";\n    src: url("').concat(Q, '/assets/fonts/museo700-regular-webfont.woff2") format("woff2"),\n      url("').concat(Q, '/assets/fonts/museo700-regular-webfont.woff") format("woff");\n    font-weight: 700;\n    font-style: normal;\n  }\n  \n  @font-face {\n    font-family: "Museo";\n    src: url("https://db.onlinewebfonts.com/t/8dfacbebef24c7bcdef86c61dbe555f9.eot");\n    src: url("https://db.onlinewebfonts.com/t/8dfacbebef24c7bcdef86c61dbe555f9.eot?#iefix") format("embedded-opentype"),\n      url("https://db.onlinewebfonts.com/t/8dfacbebef24c7bcdef86c61dbe555f9.woff2") format("woff2"), url("https://db.onlinewebfonts.com/t/8dfacbebef24c7bcdef86c61dbe555f9.woff") format("woff"),  url("https://db.onlinewebfonts.com/t/8dfacbebef24c7bcdef86c61dbe555f9.ttf") format("truetype"),  \n      url("https://db.onlinewebfonts.com/t/8dfacbebef24c7bcdef86c61dbe555f9.svg#Museo") format("svg"); \n  }\n'),
      $ = (q.text.primary, h({
    typography: W,
    fonts: _,
    palette: q,
    stylesheet: Y,
    MuiTheme: K,
    colorList: G,
    elementConfig: {
      Quote: {
        config: {
          lineTop: !1
        }
      }
    }
  })),
      U = i({
    body1: {
      name: "Body 1",
      style: {
        fontSize: "calc(1rem + 0.1em + 0.15vw)",
        lineHeight: 1.66
      }
    },
    body2: {
      name: "Body 1",
      style: {
        fontSize: "calc(0.825rem + 0.1em + 0.15vw)",
        lineHeight: 1.66
      }
    },
    h1: {
      name: "Koptekst",
      style: {
        fontSize: "calc(1rem + 3em)",
        lineHeight: 1,
        letterSpacing: "0.02em",
        textTransform: "unset"
      }
    },
    h2: {
      name: "Subtitel",
      style: {
        fontSize: "calc(1rem + 2.5em)",
        lineHeight: 1,
        letterSpacing: "0.02em",
        textTransform: "unset"
      }
    },
    h3: {
      name: "Introtekst",
      style: {
        fontSize: "calc(1rem + 1.25em)",
        lineHeight: 1.1,
        letterSpacing: "0.02em",
        textTransform: "unset"
      }
    },
    h4: {
      name: "Sub-subtitel",
      style: {
        fontSize: "calc(1rem + 0.66em)",
        lineHeight: 1.3,
        letterSpacing: "0.02em",
        textTransform: "unset"
      }
    },
    h5: {
      name: "Bijschrift",
      style: {
        fontSize: "calc(1rem + 0.5em)",
        lineHeight: 1.2,
        letterSpacing: "0.02em",
        textTransform: "unset"
      }
    },
    h6: {
      name: "Paragraaf",
      style: {
        fontSize: "calc(1.1rem + 0.2em)",
        lineHeight: 1.2,
        letterSpacing: "0.02em",
        fontWeight: 400,
        textTransform: "unset"
      }
    },
    caption: {
      name: "Caption",
      style: {
        fontSize: "calc(0.5rem + 0.1em + 0.15vw)",
        lineHeight: 1.33
      }
    },
    button: {
      name: "Button",
      style: {
        textTransform: "none",
        fontSize: "calc(0.875rem + 0.1em + 0.05vw)"
      }
    }
  }),
      V = y({
    primary: {
      name: "Domaine",
      fontFamily: "Domaine, sans-serif"
    },
    secondary: {
      name: "Montserrat",
      fontFamily: "Montserrat, sans-serif"
    }
  }),
      J = s()({
    primary: {
      main: "#F85B00",
      light: "#FFECE1",
      dark: "#FFC583"
    },
    secondary: {
      main: "#A1D7DD",
      light: "#EDF7F9"
    },
    text: {
      primary: "#000"
    }
  }),
      X = ["#fff", "#4a4a4a", J.text.primary, J.primary.main, J.primary.light, J.secondary.main, J.secondary.light, "#DAEAC9"],
      Z = p(U, {
    spacing: 12,
    palette: J,
    typography: {
      fontFamily: V.primary.fontFamily
    },
    shape: {
      borderRadius: 0
    },
    props: {
      MuiCard: {
        elevation: 0
      },
      MuiExpansionPanel: {
        elevation: 0
      },
      MuiInputLabel: {
        shrink: !0
      },
      MuiTypography: {
        variant: "body2"
      }
    },
    overrides: {
      MuiTypography: {
        paragraph: {
          marginBottom: "1.66em"
        },
        gutterBottom: {
          marginBottom: "0.5em"
        }
      },
      MuiButton: {
        outlined: {
          borderRadius: 50,
          paddingLeft: 36,
          paddingRight: 36
        }
      },
      MuiLink: {
        root: {
          color: "inherit"
        }
      }
    }
  }),
      ee = window.location.origin,
      te = "\n@font-face { \n  font-family: 'Domaine';\n   src: url('".concat(ee, "/assets/fonts/DomaineDisplayWeb-Regular.woff2') format('woff'), \n    url('").concat(ee, "/assets/fonts/DomaineDisplayWeb-Regular.woff') format('woff'); \n}\n\n@font-face { \n  font-family: 'Domaine'; \n  font-style: italic; \n  src: url('").concat(ee, "/assets/fonts/DomaineDisplayWeb-RegularItalic.woff2') format('woff'),\n  url('").concat(ee, "/assets/fonts/DomaineDisplayWeb-RegularItalic.woff') format('woff');\n} \n\n@font-face { \n  font-family: 'Domaine'; \n  src: url('").concat(ee, "/assets/fonts/DomaineDisplayWeb-Medium.woff2') format('woff'),\n    url('").concat(ee, "/assets/fonts/DomaineDisplayWeb-Medium.woff') format('woff');  \n    font-weight: 500;  \n  }"),
      ne = Object(f.makeStyles)(function (e) {
    return {
      root: {
        padding: e.spacing(0),
        flexDirection: "column",
        textDecoration: "none",
        position: "relative",
        color: "#000",
        backgroundColor: "transparent",
        cursor: "pointer",
        transition: e.transitions.create(["padding", "background"], {
          duration: "0.3s"
        }),
        "&:before": {
          content: '""',
          position: "absolute",
          left: "-5%",
          top: "10%",
          width: "110%",
          height: "100%",
          display: "block",
          background: "#e4e4e400",
          transition: e.transitions.create(["padding", "background"], {
            duration: "0.3s"
          })
        },
        "&:hover img": {
          transform: "translateY(-15px)"
        }
      },
      container: {},
      image: {
        boxShadow: e.shadows[10],
        objectFit: "cover",
        msInterpolationMode: "bicubic",
        minHeight: "1px",
        width: "100%",
        transition: "transform 0.3s ease-out"
      },
      title: {
        backgroundColor: "rgba(0, 0, 0, 0)",
        paddingTop: 8,
        lineHeight: 1.2,
        zIndex: 2,
        fontFamily: "Montserrat",
        fontSize: "15px !important"
      },
      index: {
        background: "#ffc583",
        color: "#E9550D",
        bottom: 50,
        borderRadius: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        left: e.spacing(-1),
        width: e.spacing(3),
        height: e.spacing(3),
        fontFamily: "Montserrat"
      }
    };
  }),
      re = (V.primary.fontFamily, J.primary.dark, J.primary.main, J.primary.dark, J.primary.main, h({
    typography: U,
    fonts: V,
    palette: J,
    stylesheet: te,
    MuiTheme: Z,
    colorList: X,
    elementConfig: {
      Quote: {
        config: {
          lineTop: !0
        }
      }
    },
    elements: {
      CoverButton: function CoverButton(e) {
        var t = e.element,
            n = ne(),
            r = t.config,
            o = r.image,
            a = r.title,
            i = r.index;
        return z.createElement("div", {
          className: n.root
        }, z.createElement("div", {
          className: n.container
        }, z.createElement("img", {
          className: n.image,
          src: o,
          alt: o
        }), z.createElement("div", {
          className: n.index
        }, i), z.createElement(f.Typography, {
          variant: "body1",
          className: n.title
        }, a)));
      }
    }
  })),
      oe = s()({
    primary: {
      main: "#00B3BE",
      light: "#A6D9DA"
    },
    secondary: {
      main: "#13965A",
      light: "#93CDB3"
    },
    text: {
      primary: "#4D4D4F"
    }
  }),
      ae = ["#fff", "#000", oe.text.primary, oe.primary.main, oe.primary.light, oe.secondary.main, oe.secondary.light, "#DAEAC9"],
      ie = i({
    h1: {
      name: "Koptekst",
      component: "h1",
      style: {
        fontSize: "calc(1rem + 3em)",
        lineHeight: 1,
        letterSpacing: "0.02em",
        textTransform: "unset",
        color: oe.primary.main,
        fontWeight: 500
      }
    },
    h2: {
      name: "Subtitel",
      component: "h2",
      style: {
        fontSize: "calc(1rem + 1.5em)",
        lineHeight: 1,
        letterSpacing: "0.02em",
        textTransform: "unset",
        fontWeight: 700
      }
    },
    h3: {
      name: "Introtekst",
      component: "h3",
      style: {
        fontSize: "calc(1rem + 0.25em)",
        lineHeight: 1.3,
        letterSpacing: "0.02em",
        textTransform: "unset"
      }
    },
    h4: {
      name: "Sub-subtitel",
      component: "h4",
      style: {
        fontSize: "calc(1rem + 0.4em)",
        lineHeight: 1.3,
        letterSpacing: "0.02em",
        textTransform: "unset"
      }
    },
    h5: {
      name: "Bijschrift",
      component: "h5",
      style: {
        fontSize: "calc(1rem + 0.5em)",
        lineHeight: 1.2,
        letterSpacing: "0.02em",
        textTransform: "unset"
      }
    },
    h6: {
      name: "Paragraaf",
      component: "h6",
      style: {
        fontSize: "calc(1.1rem + 0.2em)",
        lineHeight: 1.2,
        letterSpacing: "0.02em",
        fontWeight: 400,
        textTransform: "unset"
      }
    },
    caption: {
      name: "Caption",
      style: {
        fontSize: "calc(0.5rem + 0.1em + 0.15vw)",
        lineHeight: 1.33
      }
    },
    button: {
      name: "Button",
      style: {
        textTransform: "none",
        fontSize: "calc(0.875rem + 0.1em + 0.05vw)"
      }
    },
    body1: {
      name: "Body 1",
      style: {
        fontSize: "calc(1rem + 0.1em + 0.15vw)",
        lineHeight: 1.66
      }
    },
    body2: {
      name: "Body 2",
      style: {
        fontSize: 15,
        lineHeight: 1.66
      }
    }
  }),
      le = y({
    primary: {
      name: "Museo",
      fontFamily: "Museo, sans-serif"
    }
  }),
      se = p(ie, {
    spacing: 12,
    typography: {
      fontFamily: le.primary.fontFamily
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
      }
    },
    palette: oe,
    shape: {
      borderRadius: 0
    },
    props: {
      MuiCard: {
        elevation: 0
      },
      MuiExpansionPanel: {
        elevation: 0
      },
      MuiInputLabel: {
        shrink: !0
      },
      MuiTypography: {
        variant: "body2"
      }
    },
    overrides: {
      MuiTypography: {
        paragraph: {
          marginBottom: "1.66em"
        },
        gutterBottom: {
          marginBottom: "0.5em"
        }
      },
      MuiButton: {
        outlined: {
          borderRadius: 50,
          paddingLeft: 36,
          paddingRight: 36
        }
      },
      MuiLink: {
        root: {
          color: "inherit"
        }
      }
    }
  }),
      fe = window.location.origin,
      ce = '\n  @font-face {\n  font-family: "Museo";\n  src: url("'.concat(fe, '/assets/fonts/museosans_500-webfont.woff2") format("woff2"),\n    url("').concat(fe, '/assets/fonts/museosans_500-webfont.woff") format("woff");\n  font-weight: 500;\n  font-style: normal;\n  } \n\n  @font-face {\n    font-family: "Museo";\n    src: url("').concat(fe, '/assets/fonts/museo700-regular-webfont.woff2") format("woff2"),\n      url("').concat(fe, '/assets/fonts/museo700-regular-webfont.woff") format("woff");\n    font-weight: 700;\n    font-style: normal;\n  }\n  @font-face {\n    font-family: "Museo";\n    src: url("https://db.onlinewebfonts.com/t/8dfacbebef24c7bcdef86c61dbe555f9.eot");\n    src: url("https://db.onlinewebfonts.com/t/8dfacbebef24c7bcdef86c61dbe555f9.eot?#iefix") format("embedded-opentype"),\n      url("https://db.onlinewebfonts.com/t/8dfacbebef24c7bcdef86c61dbe555f9.woff2") format("woff2"), url("https://db.onlinewebfonts.com/t/8dfacbebef24c7bcdef86c61dbe555f9.woff") format("woff"),  url("https://db.onlinewebfonts.com/t/8dfacbebef24c7bcdef86c61dbe555f9.ttf") format("truetype"),  \n      url("https://db.onlinewebfonts.com/t/8dfacbebef24c7bcdef86c61dbe555f9.svg#Museo") format("svg"); \n  }\n'),
      me = Object(f.makeStyles)(function (e) {
    return {
      root: {
        position: "relative",
        maxWidth: 300,
        flex: 1,
        width: "100%",
        "&:hover > $container": {
          transform: "translateY(-5%)",
          boxShadow: e.shadows[20]
        }
      },
      container: {
        transition: "all 0.3s",
        transform: "translateY(0)",
        boxShadow: e.shadows[8],
        "&:after": {
          top: "20%",
          left: 0,
          right: 0,
          bottom: 0,
          content: "' '",
          position: "absolute",
          backgroundSize: "cover",
          backgroundImage: "url(https://d3m8frrq3asli4.cloudfront.net/mst/index/gradient.png)",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top center"
        }
      },
      image: {
        width: "100%"
      },
      title: {
        position: "absolute",
        color: "#fff",
        bottom: 0,
        zIndex: 10,
        fontSize: "1.1rem",
        fontWeight: 700,
        padding: "7% 10%",
        lineHeight: 1
      },
      index: {
        position: "absolute",
        background: "#fff",
        width: 40,
        height: 40,
        borderRadius: "100%",
        top: "5%",
        left: -10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: e.shadows[6],
        fontWeight: 700,
        fontSize: "1rem",
        zIndex: 11
      }
    };
  }),
      ue = (le.primary.fontFamily, oe.text.primary, oe.text.primary, h({
    typography: ie,
    fonts: le,
    palette: oe,
    stylesheet: ce,
    MuiTheme: se,
    colorList: ae,
    elements: {
      CoverButton: function CoverButton(e) {
        var t = e.element,
            n = me(),
            r = t.config,
            o = r.image,
            a = r.title,
            i = r.index;
        return z.createElement("div", {
          className: n.root
        }, z.createElement("div", {
          className: n.container
        }, z.createElement("img", {
          className: n.image,
          src: o,
          alt: o
        }), z.createElement("div", {
          className: n.index
        }, i), z.createElement(f.Typography, {
          variant: "body1",
          className: n.title
        }, a)));
      }
    },
    elementConfig: {
      Quote: {
        config: {
          lineTop: !0
        }
      }
    }
  }));

  [Element.prototype, CharacterData.prototype, DocumentType.prototype].forEach(function (e) {
    e.hasOwnProperty("remove") || Object.defineProperty(e, "remove", {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: function value() {
        this.parentNode.removeChild(this);
      }
    });
  });

  var pe = function pe(e) {
    if (e) {
      var t = document.head || document.getElementsByTagName("head")[0],
          n = document.createElement("style");
      t.querySelectorAll(".greenzeen-theme").forEach(function (e) {
        e.remove();
      }), n.type = "text/css", n.className = "greenzeen-theme", n.appendChild(document.createTextNode(e)), t.appendChild(n);
    }
  },
      ye = n(3),
      ge = {
    default: $,
    bondig: re,
    carmelKoers2025: N,
    carmelKennismaking: D,
    mst: ue
  },
      de = function de() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "default",
        t = ge[e] || ge.default;
    return ye.Content.configure({
      components: t.elements
    }), pe(t.stylesheet), t;
  },
      he = function he() {
    return Object.keys(ge);
  };

  function be(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function we(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? be(Object(n), !0).forEach(function (t) {
        ve(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : be(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function ve(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var Se = {
    tenant: "default"
  },
      Oe = {
    configure: function configure(e) {
      Se = we(we({}, Se), e);
    },

    get config() {
      return Se;
    }

  },
      xe = function xe(e) {
    return e = e || Oe.config.tenant, de(e || Oe.config.tenant);
  },
      je = n(4),
      Fe = function Fe(e) {
    var t = e.value,
        n = e.onChange,
        r = xe().colorList;
    return z.createElement(je.TwitterPicker, {
      colors: r,
      color: t,
      triangle: "hide",
      onChangeComplete: function onChangeComplete(e) {
        return n(e.hex);
      }
    });
  },
      De = function De(e) {
    var t = e.value,
        n = e.onChange,
        r = xe().fonts;
    return z.createElement(f.Select, {
      fullWidth: !0,
      value: t,
      onChange: function (e) {
        function t(t) {
          return e.apply(this, arguments);
        }

        return t.toString = function () {
          return e.toString();
        }, t;
      }(function (e) {
        return n(e.target.value);
      })
    }, Object.keys(r).map(function (e) {
      return z.createElement(f.MenuItem, {
        key: e,
        value: e
      }, r[e].name);
    }));
  };

  function Ee() {
    return (Ee = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function Me(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          o = !1,
          a = void 0;

      try {
        for (var i, l = e[Symbol.iterator](); !(r = (i = l.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, a = e;
      } finally {
        try {
          r || null == l.return || l.return();
        } finally {
          if (o) throw a;
        }
      }

      return n;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return Pe(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Pe(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function Pe(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  var ke = function ke(e) {
    var t = e.value,
        n = e.onChange,
        r = xe().typography,
        o = {},
        a = Me(z.useState(t), 2),
        i = a[0],
        l = a[1],
        s = Me(z.useState(!1), 2),
        c = s[0],
        m = s[1];
    return z.createElement(f.Select, {
      value: i,
      fullWidth: !0,
      onOpen: function onOpen() {
        return m(!0);
      },
      onClose: function onClose() {
        return m(!1);
      },
      onChange: function (e) {
        function t(t) {
          return e.apply(this, arguments);
        }

        return t.toString = function () {
          return e.toString();
        }, t;
      }(function (e) {
        l(e.target.value), n(e.target.value);
      })
    }, Object.keys(r).map(function (e) {
      var t = r[e];
      return z.createElement(f.MenuItem, {
        key: e,
        value: e
      }, c || i !== e ? z.createElement(f.Typography, Ee({}, o, {
        variant: e,
        style: t.style || {}
      }), t.name) : t.name);
    }));
  };
}]));